import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCookieConsent } from "@/context/CookieConsentContext";
import { track } from "@/lib/analytics";

// Fires a consent-gated, anonymous pageview whenever the route changes.
export function AnalyticsTracker() {
  const { consent } = useCookieConsent();
  const location = useLocation();
  useEffect(() => {
    if (!consent?.analytics) return;
    track("pageview", location.pathname);
  }, [location.pathname, consent?.analytics]);
  return null;
}
